import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paper: {
    width: 800,
    height: 900,
    maxWidth: 'calc(100% - 20px)',
    maxHeight: 'calc(100% - 20px)',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    backgroundColor: '#f4f4f4',
    padding: '1em 2.5em 0',
    position: 'relative',
  },
  btnGroup: {
    background: '#fff',
  },
  divider: {
    display: 'inline-block',
    width: 7,
    heigth: 20,
  },
  toolbar: {
    marginBottom: 5,
  },
  editor: {
    borderTop: '1px solid #ddd',
    cursor: 'text',
    fontSize: 16,
    marginTop: 20,
    minHeight: 400,
    paddingTop: 20,
  },
  '@media(max-width: 500px)': {
    header: {
      padding: '1em 1.5em 5px',
    },
    paper: {
      maxWidth: '100%',
      maxHeight: '100%',
    },
  }
}));